module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBmaWxsPSJub25lIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiPjxnPjxnPjxyZWN0IHg9IjIuMjg1NjQ0NTMxMjUiIHk9IjIuMjg1NzY2NjAxNTYyNSIgd2lkdGg9IjMuNDI4NTcxMjI0MjEyNjQ2NSIgaGVpZ2h0PSIzLjQyODU3MTIyNDIxMjY0NjUiIHJ4PSIxLjcxNDI4NTYxMjEwNjMyMzIiIGZpbGw9IiNGRjgwQ0YiIGZpbGwtb3BhY2l0eT0iMSIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/img_point-2.svg
// module id = APlI
// module chunks = 1